// extracted by mini-css-extract-plugin
var _1 = "EvNOR";
var _2 = "oRqLD";
var _3 = "Mfj4V";
var _4 = "AJTZE";
export { _1 as "layout", _2 as "layoutWhite", _3 as "main", _4 as "white" }
